import { call, put, select, takeLatest, delay } from 'redux-saga/effects';

import {
	getPurchases,
	getPurchasesFailure,
	getPurchasesSuccess,
	getPurchaseByClientId,
	getPurchaseByClientIdFailure,
	getPurchaseByClientIdSuccess,
	getPurchaseById,
	getPurchaseByIdFailure,
	getPurchaseByIdSuccess,
	getPurchaseStatuses,
	getPurchaseStatusesFailure,
	getPurchaseStatusesSuccess,
} from '.';

import purchaseService from '../../../services/PurchaseService';

function* rootSaga() {
	yield takeLatest(getPurchases, getPurchasesSaga);
	yield takeLatest(getPurchaseById, getPurchaseByIdSaga);
	yield takeLatest(getPurchaseStatuses, getPurchaseStatusesSaga);
	yield takeLatest(getPurchaseByClientId, getPurchaseByClientIdSaga);
}

function* getPurchasesSaga({ payload }) {
	try {
		yield delay(300);
		const response = yield call(purchaseService.getAll, payload);
		yield put(getPurchasesSuccess(response));
	} catch (error) {
		yield put(getPurchasesFailure(error));
	}
}

function* getPurchaseByIdSaga({ payload }) {
	const purchaseId = payload;
	try {
		yield delay(300);
		const response = yield call(purchaseService.get, purchaseId);
		yield put(getPurchaseByIdSuccess(response));
	} catch (error) {
		yield put(getPurchaseByIdFailure(error));
	}
}

function* getPurchaseStatusesSaga({ payload }) {
	try {
		yield delay(300);
		const response = yield call(purchaseService.getStatuses);
		yield put(getPurchaseStatusesSuccess(response));
	} catch (error) {
		yield put(getPurchaseStatusesFailure(error));
	}
}

function* getPurchaseByClientIdSaga({ payload }) {
	try {
		yield delay(300);
		const { clientId, page = 1, size = 10 } = payload || {};
		const response = yield call(purchaseService.getByClientId, clientId, { page, size });
		yield put(getPurchaseByClientIdSuccess(response));
	} catch (error) {
		yield put(getPurchaseByClientIdFailure(error));
	}
}

export default rootSaga;
